'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_jquery2.default.fn.dataTable.ext.buttons.reload = {
	name: 'reload',
	className: 'buttons-reload',
	text: function text(dt) {
		return dt.i18n('buttons.reload', 'Reload');
	},
	action: function action(e, dt, node, config) {
		dt.ajax.reload(null, true);
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/data-tables/buttons/reload.js
// module id = 481
// module chunks = 0